import { useEffect, useState } from 'react';
export function usePagination(initialStart: number = 0, initialTotal: number, deps: any[] = []) {
  const [isLoading, setIsLoading] = useState(false);
  const [start, setStart] = useState(initialStart);
  const [total, setTotal] = useState(initialTotal);

  // force the state update to prevent the latency of the first fetch
  useEffect(() => {
    setStart(initialStart);
    setTotal(initialTotal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  function onPaginateStart() {
    setIsLoading(true);
  }
  function onPaginateComplete(start: number, total: number) {
    setStart(start);
    setTotal(total);
    setIsLoading(false);
  }
  return {
    isLoading,
    start,
    total,
    onPaginateStart,
    onPaginateComplete
  };
}